import { FormGroup, ValidatorFn } from '@angular/forms';

export function requiredAtLeastThreeValidator(minRequired =3): ValidatorFn {
  return function validate (formGroup: FormGroup) {
    let inputValue = 0;

    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.controls[key];

      if (control.value ) {
        inputValue ++;
      }
    });

    if (inputValue < minRequired) {
      return {
        requireOneCheckboxToBeChecked: true,
      };
    }

    return null;
  };
}
